var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6370_38280",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 20 0.000732422)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6370_38280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93741 10.0008L14.0624 3.87577C14.2707 3.66744 14.3714 3.42091 14.3645 3.13619C14.3575 2.85147 14.2499 2.60494 14.0416 2.39661C13.8332 2.18827 13.5867 2.08411 13.302 2.08411C13.0173 2.08411 12.7707 2.18827 12.5624 2.39661L6.16658 8.81327C5.99991 8.97994 5.87491 9.16744 5.79158 9.37577C5.70824 9.58411 5.66658 9.79244 5.66658 10.0008C5.66658 10.2091 5.70824 10.4174 5.79158 10.6258C5.87491 10.8341 5.99991 11.0216 6.16658 11.1883L12.5832 17.6049C12.7916 17.8133 13.0346 17.914 13.3124 17.907C13.5902 17.9001 13.8332 17.7924 14.0416 17.5841C14.2499 17.3758 14.3541 17.1292 14.3541 16.8445C14.3541 16.5598 14.2499 16.3133 14.0416 16.1049L7.93741 10.0008Z",
    fill: "#4A7495"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevronLeft.19f3c04acf4b61e4305fb345db4f72fe.svg";
export { ForwardRef as ReactComponent };